<template>
    <template v-if="indexAlgolia">
      <div class="input-card col-md-6 mx-lg-auto">
        <div class="input-card-form">
        <input type="text" v-model="query" @keydown="BuscarenAlgolia" class="form-control" :placeholder="placeholder" />
        </div>
        <button type="button" class="btn btn-primary btn-icon" @click="BuscarenAlgolia">
          <i class="bi-search"></i>
        </button>
    </div>
    </template>
     <template v-if="answers.length > 0">

    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">

            <template v-for="(answer, index) in answers" :key="index">
                <div class="card p-2 text-center card-transition bg-soft-primary-light" style="margin-top:15px; cursor: pointer;" v-if="answer.data == response" @click="SeleccionarRespuesta(answer)">
                    <div class="text-center">
                     <div class="card-body">
                        <p class="card-title"><strong>{{answer.title}}</strong></p>
                        <p class="card-text">{{answer.help}}</p>
                    </div>
                    </div>
                </div>

                <div class="card p-2 text-center card-transition card-selection" style="margin-top:15px; cursor: pointer;" @click="SeleccionarRespuesta(answer)" v-else>
                    <div class="text-center">
                     <div class="card-body">
                        <p class="card-title"><strong>{{answer.title}}</strong></p>
                        <p class="card-text">{{answer.help}}</p>
                    </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
     </template>
</template>

<script>

import algoliasearch from 'algoliasearch/lite';


export default {
  name: 'AlgoliaSearchOne',
  props: {

    response: {
        type: [Number, String]
    },    
    indexAlgolia: String,
    FormularioTag: String,
    idQuestion: Number,
    AlgoliaApiKey: String,
    AlgoliaUser: String,
    AlgoliaRefQuestion: String,
    AlgoliaRefData: String,
    AlgoliaRefHelp: String,
    placeholder: String,
    answers: Array


  },
  data: function(){

      return {

        query : null
      }


  },
    mounted: function(){
        
      
    },

  methods: {

      SeleccionarRespuesta : function(answer){


        let respuesta = answer.data;

        let Mutation = {

            formulario: this.FormularioTag,
            question: this.idQuestion,
            response: respuesta,
            validate: true
        }

        window.scrollTo(0, 0);

            
        this.$store.commit('actualizarRespuestaFormulario', Mutation);


      },

      BuscarenAlgolia : function(){
        
        var client = algoliasearch(this.AlgoliaUser, this.AlgoliaApiKey);
        var index = client.initIndex(this.indexAlgolia);

        let DatosAlgolia = index.search(this.query, {hitsPerPage: 5}).then(({ hits }) => {

            var opcionesRespuesta = [];

            var Resultados = hits;

            for (let res in Resultados)
            {

                let resultado = Resultados[res];


                var DatosEnBruto = {};


                if (this.AlgoliaRefQuestion != null && this.AlgoliaRefData)
                {

                    DatosEnBruto["data"] = resultado[this.AlgoliaRefData];
                    DatosEnBruto["title"] = resultado[this.AlgoliaRefQuestion];

                } else {

                    if (this.AlgoliaRefQuestion != null)
                    {

                        DatosEnBruto["data"] = resultado[this.AlgoliaRefQuestion];
                        DatosEnBruto["title"] = resultado[this.AlgoliaRefQuestion];
                    }

                }

               if (this.AlgoliaRefHelp != null)
                {

                    DatosEnBruto["help"] = resultado[this.AlgoliaRefHelp];

                }


                if (DatosEnBruto["data"] && DatosEnBruto["title"])
                {

                    
                    opcionesRespuesta.push(DatosEnBruto);


                }

            }


            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                answers: opcionesRespuesta

            }


            this.$store.commit('actualizarOpcionesdeRespuesta', Mutation);


        });


   


      }


  }
}
</script>